<div class="fab-container px-3 md:hidden" [ngClass]="{ 'justify-content-end': items.length == 1 }">
  <p-button
    *ngFor="let item of items"
    [class]="'fab-button ' + item.styleClass"
    [label]="item.label"
    (onClick)="execute(item, $event)">
    <i class="pi" [ngClass]="item.icon"></i>
  </p-button>
</div>
